import React from 'react'

import { useGetColor } from '../../packages/kiti/components/theme/_hooks/colors'
import Tag from '../../components/presentation/Tag'

/**
 * Exibe uma tag genérica (`Models.Tag`) como uma pílula colorida, usando `tag.name` e `tag.color`.
 * Não renderiza nada quando não há tag (ex.: atividade sem tag atribuída), para não quebrar layout.
 *
 * Usa o mesmo `Tag` e o mesmo tamanho padrão (sem `small`) do `StatusTag`, que renderiza status e
 * prioridade, para a tag de atividade ter exatamente o mesmo formato/altura/fonte desses chips.
 */
const TagPresenter = ({ tag, ...props }) => {
  const getColor = useGetColor()

  if (!tag?.name) return false

  return <Tag label={tag.name} bgColor={getColor(tag.color)} {...props} />
}

export default TagPresenter
